import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateAcademicSemesters = () => {
  return (
    <Create
      title="Създаване на академичен семестър"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateAcademicSemesters;
